import e6Tab from "./src/main";
e6Tab.install = function(Vue) {
  Vue.component(e6Tab.name, e6Tab);
};
export default e6Tab;
